import { z } from "zod";

export const FormatStrings = z.record(z.string(), z.record(z.string()));

export type FormatStrings = z.infer<typeof FormatStrings>;
